export default "__VITE_ASSET__BsIKcT65__"